import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["marrakech-to-taghazout-tamraght"];

export const Route = createFileRoute("/transfers/marrakech-to-taghazout-tamraght")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
